export default __webpack_public_path__ + "static/media/blue-bag-active.3dca147d.png";